import useMediaQuery from "../../../../hooks/useMediaQuery";
import { useTranslation } from "react-i18next";
import { SubTitle } from "../../../../components/ui/typography/subTitle";
import Skeleton from "../../../../components/ui/skeleton";
import { Link, useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/scss";
import { Button } from "../../../../components/ui/button";
import { useTanstack } from "../../../../hooks/useTanstack";
import styles from "./news.module.scss";

export const News = () => {
  const navigate = useNavigate();

  const { t } = useTranslation();
  const { data } = useTanstack("getWebNews");

  const laptopSmall = useMediaQuery(`( max-width: 1099px )`);
  const mobile = useMediaQuery(`( max-width: 768px )`);

  const skeletonCount = laptopSmall && !mobile ? 2 : 3;

  return (
    <div className={styles.news}>
      <div className="container">
        <div className={styles.news_top}>
          <SubTitle text="news" />
        </div>

        {!data ? (
          <Skeleton type="news" number={skeletonCount} />
        ) : (
          <div className={styles.news_swiper}>
            {mobile ? (
              <div className={styles.news_row}>
                {data?.slice(0, 3)?.map(({ id, image, title, description }) => (
                  <Link
                    key={id}
                    title={title}
                    to={`news/${id}`}
                    className={styles.news_col}
                  >
                    <h3>{title}</h3>
                    <p>{description}</p>
                    <img src={image} alt={`news${id}`} loading="lazy" />
                  </Link>
                ))}
              </div>
            ) : (
              <Swiper
                spaceBetween={30}
                pagination={{
                  clickable: true,
                }}
                speed={1000}
                loop={false}
                modules={[Navigation]}
                navigation={true}
                updateOnWindowResize={false}
                className={styles.services_row}
                breakpoints={{
                  1100: {
                    slidesPerView: 3,
                  },
                  768: {
                    slidesPerView: 2,
                  },
                }}
              >
                {data?.map(({ id, image, title, description }) => {
                  return (
                    <SwiperSlide
                      title={title}
                      key={id}
                      onClick={() => navigate(`news/${id}`)}
                      className={styles.news_col}
                    >
                      <h3>{title}</h3>
                      <p>{description}</p>
                      <img src={image} alt={`news${id}`} loading="lazy" />
                    </SwiperSlide>
                  );
                })}
              </Swiper>
            )}
          </div>
        )}
        <div className={styles.news_more}>
          <Button
            type="button"
            onClick={() => navigate("news")}
            text={t("see_all")}
            className={styles.news_moreBtn}
          />
        </div>
      </div>
    </div>
  );
};
